import AdminAnalytics from "../group/AdminAnalytics";

export default function AccountantDashboard() {
  return <AdminAnalytics pageMode="accountant" />;
}
